const FAQData = [
    {
      question: "What is insurance, and why do I need it?",
      answer:
        "Insurance is a financial safety net that protects you against unexpected losses, such as accidents, illnesses, or property damage.",
    },
    {
      question: "What types of insurance policies are available?",
      answer: "Life, health, auto, home, travel, and more.",
    },
    {
      question: "What does a typical insurance policy cover?",
      answer: "It depends on the type, but usually covers loss, damage, or liability.",
    },
    {
      question: "How long does it take to process a claim?",
      answer: "Typically takes 7-14 business days after submission.",
    },
    {
      question: "Can I cancel my policy anytime?",
      answer: "Yes, but cancellation rules and fees may apply depending on the provider.",
    },
    {
      question: "What documents are required to file a claim?",
      answer: "Usually ID proof, policy number, and incident-related documents.",
    },
  ];
  
  export default FAQData;
  